import type { FlowAdSettingsSelection } from 'hooks';
import type { TwitterAdSettingsPayload, TwitterAdSettingsResponse } from '../api/types';
import { findTextById, getDefaultLocale, getDefaultTextId } from './adSettingsDefaults';

/** Keeps a URL ad-settings entry only when its flow, text and locale exist on the backend. */
export const resolveDeepLinkAdSettings = (
  urlSettings: Readonly<Record<string, FlowAdSettingsSelection | undefined>>,
  settingsData: TwitterAdSettingsResponse,
): Record<string, TwitterAdSettingsPayload> =>
  Object.fromEntries(
    Object.entries(settingsData).map(([flow, settings]) => {
      const fromUrl = urlSettings[flow];
      const urlText = findTextById(settings.texts, fromUrl?.text_id);
      if (fromUrl && urlText && urlText.locales.includes(fromUrl.locale)) {
        return [flow, { text_id: String(urlText.id), locale: fromUrl.locale }];
      }

      const textId = getDefaultTextId(settings.texts);
      return [flow, { text_id: textId, locale: getDefaultLocale(findTextById(settings.texts, textId)) }];
    }),
  );
